<template>
  <v-flex xs12 ma-4>

    <v-row>
      <v-col>
        <v-card
          outlined
          tile
          v-if="hasAllAbilities($constants.ABILITY.RUN_PIPELINE)
           && !hasSomeAbilities($constants.ABILITY.INTERN)"
        >
          <v-card-title>
            <span>Pipelines:</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="getGitlabPipeline">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col v-for="pipeline in pipelines" :key="pipeline.stage" align="center" cols="4">
                <v-btn
                  @click="deployDialog.stage = pipeline.stage;deployDialog.show = true"
                  :color="pipeline.stage === 2 ? 'red' : ''"
                >
                  Run {{ pipeline.name }}
                  <v-divider class="mx-2" vertical dark></v-divider>

                  <v-menu offset-y :close-on-content-click="false" left v-if="pipeline.last">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click.stop
                        :color="pipeline.last.status === 'failed' ? 'error' : pipeline.last.status"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>

                    <!-- last run info -->
                    <v-card min-width="250">
                      <v-card-title class="text-subtitle-1 pb-1">Last run</v-card-title>
                      <v-card-text>
                        <div><strong>Time: </strong>{{ pipeline.last.time_since_creation }}</div>
                        <div>
                          <strong>Status: </strong>
                          <v-chip x-small :color="pipeline.last.status === 'failed' ? 'error' : pipeline.last.status">
                            {{ pipeline.last.status }}
                          </v-chip>
                        </div>
                        <div class="mt-1 text-caption text-truncate">
                          {{ pipeline.last.errors }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <v-card
          outlined
          tile
          v-if="hasAllAbilities($constants.ABILITY.EXPORT)
           && !hasSomeAbilities($constants.ABILITY.INTERN)"
        >
          <v-card-title>Export files:</v-card-title>
          <v-card-text>
            <v-row
              align="center"
              justify="space-around"
            >
              <v-col align="center">
                <v-btn
                  @click="exportGroundDialog.show = true"
                >
                  Export ground
                </v-btn>
              </v-col>
              <v-col align="center">
                <v-btn
                  @click="exportAirplaneDialog.show = true"
                >
                  Export airplane
                </v-btn>
              </v-col>
              <v-col align="center">
                <v-btn
                  title="Download last log"
                  @click="downloadLatLog"
                >
                  Logs
                </v-btn>
              </v-col>
              <v-col align="center">
                <v-btn
                  title="Download dictionary translations"
                  @click="exportTranslationsDialog.show = true"
                >
                  Export Translations
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="deployDialog.show"
      max-width="400"
    >
      <v-card>
        <v-card-title>Run {{ pipelineTitle }} pipeline</v-card-title>
        <v-card-text>
          Are you sure you run {{ pipelineTitle }} pipeline?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="deployDialog.show = false;
                      deployDialog.loading = false;"
          >
            No
          </v-btn>
          <v-btn
            :loading="deployDialog.loading"
            color="blue darken-1"
            text
            @click="runGitlabPipeline"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="exportGroundDialog.show"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
            <span class="headline">
              Export ground files
            </span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row
              align="center"
              justify="space-between"
            >Version:
              <v-switch
                color="primary"
                class="custom-blue"
                v-model="exportGroundDialog.stage"
                :label="`${exportGroundDialog.stage
                            ? 'Live'
                            : 'Prev'}`"
              />
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                  label="Languages"
                  v-model="exportGroundDialog.languages"
                  :items="languages"
                  item-text="code"
                  item-value="code"
                  multiple
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                  label="Default language"
                  v-model="exportGroundDialog.defaultLanguage"
                  :items="languages"
                  item-text="code"
                  item-value="code"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                  label="Export version"
                  v-model="exportGroundDialog.exportVersion"
                  :items="exportVersionList"
                  item-text="label"
                  item-value="name"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="exportGroundDialog.show = false;
                      exportGroundDialog.loading = false;"
          >
            Cancel
          </v-btn>
          <v-btn
            @click="exportGround"
            :loading="exportGroundDialog.loading"
            color="blue darken-1"
            text
          >
            Export
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="exportAirplaneDialog.show"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
            <span class="headline">
              Export airplane files
            </span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
              >
                <v-file-input
                  v-model="exportAirplaneDialog.jsonFile"
                  :loading="exportAirplaneDialog.loading"
                  :disabled="exportAirplaneDialog.disabled"
                  accept=".json"
                  label="Map manager bbox + manifest"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="exportAirplaneDialog.version"
                  label="Version"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="exportAirplaneDialog.exportPath"
                  label="Export path"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="exportAirplaneDialog.dbPrefix"
                  label="DB prefix"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="exportAirplaneDialog.priority"
                  label="Priority"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="exportAirplaneDialog.maxVideos"
                  label="Max Videos"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
              >
                <v-select
                  label="Video Priority"
                  v-model="exportAirplaneDialog.videoPriority"
                  :items="priorities"
                  :item-text="item => `${item.name}`"
                  item-value="id"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
              >
                <v-checkbox
                  v-model="exportAirplaneDialog.playlists"
                  label="Playlists"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
              >
                <v-checkbox
                  v-model="exportAirplaneDialog.videoExternalLinks"
                  label="Video with external links"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
              >
                <v-checkbox
                  v-model="exportAirplaneDialog.externalLinks"
                  label="External links for all media"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
              >
                <v-select
                  label="Export version"
                  v-model="exportAirplaneDialog.exportVersion"
                  :items="exportVersionList"
                  item-text="label"
                  item-value="name"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-select
                  label="Languages"
                  v-model="exportAirplaneDialog.languages"
                  :items="languages"
                  item-text="code"
                  item-value="code"
                  multiple
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-select
                  label="Default language"
                  v-model="exportAirplaneDialog.defaultLanguage"
                  :items="languages"
                  item-text="code"
                  item-value="code"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
              >
                <v-checkbox
                  v-model="exportAirplaneDialog.updateContent"
                  label="Update exist db content"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="exportAirplaneDialog.updateGeotags"
                  label="Update geotags ids"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="exportAirplaneDialog.newPois"
                  label="New poi ids"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
              >
                <v-checkbox
                  v-model="exportAirplaneDialog.skipAddVideoForOldPoi"
                  label="Skip add new video for old poi"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
              >
                <v-select
                  label="Video Priority For old Poi"
                  v-model="exportAirplaneDialog.videoPriorityOldPoi"
                  :items="priorities"
                  :item-text="item => `${item.name}`"
                  item-value="id"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="exportAirplaneDialog.show = false;
                      exportAirplaneDialog.loading = false;
                      exportAirplaneDialog.jsonFile = null;
                      exportAirplaneDialog.version = null;
                      exportAirplaneDialog.exportPath = null;
                      exportAirplaneDialog.dbPrefix = null;
                      exportAirplaneDialog.priority = null;
                      exportAirplaneDialog.maxVideos = null;
                      exportAirplaneDialog.videoPriority = null;
                      exportAirplaneDialog.videoExternalLinks = null;
                      exportAirplaneDialog.externalLinks = null;
                      exportAirplaneDialog.playlists = null;
                      exportAirplaneDialog.disabled = false;
                      exportAirplaneDialog.updateContent = false;
                      exportAirplaneDialog.updateGeotags = null;
                      exportAirplaneDialog.skipAddVideoForOldPoi = false;
                      exportAirplaneDialog.videoPriorityOldPoi = null;
                      exportAirplaneDialog.newPois = null;"
          >
            Cancel
          </v-btn>
          <v-btn
            @click="exportAirline"
            :loading="exportAirplaneDialog.loading"
            color="blue darken-1"
            text
          >
            Export
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="exportTranslationsDialog.show"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
            <span class="headline">
              Export dictionary translations
            </span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="exportTranslationsDialog.airline"
                  label="Airline"
                />
              </v-col>
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="exportTranslationsDialog.dictionary"
                  label="Dictionary"
                  type="number"
                />
              </v-col>
              <v-col
                cols="12"
              >
                <v-checkbox
                  v-model="exportTranslationsDialog.ground"
                  label="Copy to cloud"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="this.resetExportTranslations"
          >
            Cancel
          </v-btn>
          <v-btn
            @click="exportTranslations"
            :loading="exportTranslationsDialog.loading"
            color="blue darken-1"
            text
          >
            Export
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ReleaseContent',
  data: () => ({
    deployDialog: {
      show: false,
      loading: false,
      stage: 0,
    },
    exportGroundDialog: {
      show: false,
      loading: false,
      stage: 0,
      type: 0,
      exportVersion: 'Latest',
      languages: [],
      defaultLanguage: null,
    },
    exportAirplaneDialog: {
      show: false,
      jsonFile: null,
      version: null,
      exportPath: null,
      dbPrefix: null,
      priority: null,
      maxVideos: null,
      videoPriority: null,
      videoExternalLinks: null,
      externalLinks: null,
      playlists: null,
      type: 1,
      loading: false,
      disabled: false,
      exportVersion: 'Latest',
      languages: [],
      defaultLanguage: null,
      updateContent: false,
      updateGeotags: null,
      newPois: null,
      skipAddVideoForOldPoi: false,
      videoPriorityOldPoi: null,
    },
    exportTranslationsDialog: {
      show: false,
      loading: false,
      airline: '',
      dictionary: null,
      ground: true,
    },
    priorities: [],
    languages: {},
    loading: true,
    exportVersionList: [
      { name: 'Latest', label: 'Latest' },
      { name: 'V1.12', label: 'V1.12' },
      { name: 'V1.6', label: 'V1.6' },
      { name: 'V1.5', label: 'V1.5' },
    ],
    pipelines: {},
  }),

  created() {
    this.$requestHelpers
      .get('api/admin/video/getAllPriorities')
      .then((response) => {
        this.priorities = response.data;
      });
    this.$requestHelpers
      .get('api/admin/languages-list')
      .then((response) => {
        this.languages = response.data;
      });

    this.getGitlabPipeline();
  },

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),
    runGitlabPipeline() {
      this.deployDialog.loading = true;
      this.$requestHelpers
        .post('api/admin/poi/runPipeline', { stage: this.deployDialog.stage })
        .then((response) => {
          this.pipelines = response.data;
        }).finally(() => {
          this.deployDialog.show = false;
          this.deployDialog.loading = false;
        });
    },

    getGitlabPipeline() {
      this.$requestHelpers
        .get('api/admin/poi/getLastPipelines')
        .then((response) => {
          this.pipelines = response.data;
        });
    },

    exportGround() {
      this.exportGroundDialog.loading = true;
      this.exportGroundDialog.disabled = true;

      this.$nextTick(() => {
        const data = {
          type: this.exportGroundDialog.type,
          stage: this.exportGroundDialog.stage,
          exportVersion: this.exportGroundDialog.exportVersion,
          languages: this.exportGroundDialog.languages,
          defaultLanguage: this.exportGroundDialog.defaultLanguage,
          debug: 1,
        };

        this.$requestHelpers
          .post('api/admin/poi/exportDBPois',
            data,
            {
              responseType: 'blob',
            })
          .then((response) => {
            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            const fileLink = document.createElement('a');
            const headerval = response.headers['content-disposition'];
            const filename = headerval.match(/filename=(.*)/);

            fileLink.href = fileURL;
            fileLink.setAttribute('download', filename[1]);
            fileLink.click();
          }).finally(() => {
            this.exportGroundDialog.show = false;
            this.exportGroundDialog.loading = false;
          });
      });
    },

    exportAirline() {
      if (!this.exportAirplaneDialog.jsonFile) {
        return;
      }

      this.exportAirplaneDialog.loading = true;
      this.exportAirplaneDialog.disabled = true;

      this.$nextTick(() => {
        const data = new FormData();
        data.append('json_file', this.exportAirplaneDialog.jsonFile);
        if (this.exportAirplaneDialog.version) {
          data.append('version', this.exportAirplaneDialog.version);
        }
        if (this.exportAirplaneDialog.exportPath) {
          data.append('export_path', this.exportAirplaneDialog.exportPath);
        }
        if (this.exportAirplaneDialog.dbPrefix) {
          data.append('db_prefix', this.exportAirplaneDialog.dbPrefix);
        }
        if (this.exportAirplaneDialog.priority) {
          data.append('priority', this.exportAirplaneDialog.priority);
        }
        if (this.exportAirplaneDialog.maxVideos) {
          data.append('maxVideos', this.exportAirplaneDialog.maxVideos);
        }
        if (this.exportAirplaneDialog.videoPriority !== null) {
          data.append('videoPriority', this.exportAirplaneDialog.videoPriority);
        }
        if (this.exportAirplaneDialog.videoExternalLinks) {
          data.append('videoExternalLinks', this.exportAirplaneDialog.videoExternalLinks);
        }
        if (this.exportAirplaneDialog.externalLinks) {
          data.append('externalLinks', this.exportAirplaneDialog.externalLinks);
        }
        if (this.exportAirplaneDialog.playlists) {
          data.append('playlists', this.exportAirplaneDialog.playlists);
        }
        data.append('type', this.exportAirplaneDialog.type);
        data.append('exportVersion', this.exportAirplaneDialog.exportVersion);

        if (this.exportAirplaneDialog.languages.length > 0) {
          data.append('languages', this.exportAirplaneDialog.languages);
        }
        if (this.exportAirplaneDialog.defaultLanguage) {
          data.append('defaultLanguage', this.exportAirplaneDialog.defaultLanguage);
        }
        if (this.exportAirplaneDialog.updateContent) {
          data.append('updateContent', this.exportAirplaneDialog.updateContent);
        }
        if (this.exportAirplaneDialog.updateGeotags) {
          data.append('updateGeotags', this.exportAirplaneDialog.updateGeotags);
        }
        if (this.exportAirplaneDialog.newPois) {
          data.append('newPois', this.exportAirplaneDialog.newPois);
        }
        if (this.exportAirplaneDialog.skipAddVideoForOldPoi) {
          data.append('skipAddVideoForOldPoi', this.exportAirplaneDialog.skipAddVideoForOldPoi);
        }
        if (this.exportAirplaneDialog.videoPriorityOldPoi) {
          data.append('videoPriorityOldPoi', this.exportAirplaneDialog.videoPriorityOldPoi);
        }
        data.append('debug', 1);

        this.$requestHelpers
          .post('api/admin/poi/exportDBPois',
            data,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
              responseType: 'blob',
            })
          .then((response) => {
            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            const fileLink = document.createElement('a');
            const headerval = response.headers['content-disposition'];
            const filename = headerval.match(/filename=(.*)/);

            fileLink.href = fileURL;
            fileLink.setAttribute('download', filename[1]);
            fileLink.click();
          }).finally(() => {
            this.exportAirplaneDialog.show = false;
            this.exportAirplaneDialog.loading = false;
            this.exportAirplaneDialog.jsonFile = null;
            this.exportAirplaneDialog.version = null;
            this.exportAirplaneDialog.exportPath = null;
            this.exportAirplaneDialog.dbPrefix = null;
            this.exportAirplaneDialog.priority = null;
            this.exportAirplaneDialog.maxVideos = null;
            this.exportAirplaneDialog.videoPriority = null;
            this.exportAirplaneDialog.videoExternalLinks = null;
            this.exportAirplaneDialog.externalLinks = null;
            this.exportAirplaneDialog.disabled = false;
            this.exportAirplaneDialog.updateContent = false;
            this.exportAirplaneDialog.updateGeotags = null;
            this.exportAirplaneDialog.newPois = null;
            this.exportAirplaneDialog.skipAddVideoForOldPoi = false;
            this.exportAirplaneDialog.videoPriorityOldPoi = null;
          });
      });
    },

    downloadLatLog() {
      this.$nextTick(() => {
        this.$requestHelpers
          .post('api/admin/poi/exportGetLog',
            [],
            {
              responseType: 'blob',
            })
          .then((response) => {
            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            const fileLink = document.createElement('a');
            const headerval = response.headers['content-disposition'];
            let filename = 'logFile.txt';
            if (headerval) {
              filename = headerval.match(/filename=(.*)/);
              [, filename] = filename;
            }

            fileLink.href = fileURL;
            fileLink.setAttribute('download', filename);
            fileLink.click();
          });
      });
    },

    exportTranslations() {
      this.exportTranslationsDialog.loading = true;

      this.$nextTick(() => {
        this.$requestHelpers
          .post('api/admin/export/dict-translations',
            this.exportTranslationsDialog,
            {
              responseType: 'blob',
            })
          .then((response) => {
            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            const fileLink = document.createElement('a');
            const headerval = response.headers['content-disposition'];
            const filename = headerval.match(/filename=(.*)/);

            fileLink.href = fileURL;
            fileLink.setAttribute('download', filename[1]);
            fileLink.click();
          }).finally(() => {
            this.resetExportTranslations();
          });
      });
    },

    resetExportTranslations() {
      this.exportTranslationsDialog.show = false;
      this.exportTranslationsDialog.loading = false;
      this.exportTranslationsDialog.airline = '';
      this.exportTranslationsDialog.dictionary = null;
    },
  },

  computed: {
    pipelineTitle() {
      switch (this.deployDialog.stage) {
        case 0:
          return 'PREV';
        case 1:
          return 'STAGING';
        case 2:
          return 'LIVE';
        case 3:
          return 'AIR';
        default:
          return '';
      }
    },
  },
};
</script>
